module.exports = __webpack_public_path__ + "static/media/4 Train-Lateral_Z2.faa9d72c.png";